export default {"src":"/_next/static/media/skills.363bb69e.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};